'use client'

import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { useSession } from 'session/src/hooks/useSession'
import { SESSION_MAP, SessionMapKey } from '../constants/sessionMapper'

export const useAccountLink = () => {
	const { t } = useLabels()
	const { logged } = useSession()

	const sessionMap =
		SESSION_MAP[logged ? SessionMapKey.Logged : SessionMapKey.NotLogged]

	return {
		text: t(sessionMap.text),
		accessibilityText: sessionMap.accessibilityText,
		Component: sessionMap.Component,
	}
}
